import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "fe-shared-transactions/src/components/TransactionsDataGrid/renderers";
import { GridTransactionExternal } from "../../../../types/transaction";

interface Props extends ICellRendererParams {
  data: GridTransactionExternal;
}

const CarrierRenderer = ({ data }: Props) => {
  return <TwoLineGridCell firstLineData={data.carrierDisplayName} />;
};

export default CarrierRenderer;
